import { atom } from 'recoil';
export let AgreementOption;
(function (AgreementOption) {
  AgreementOption["EXISTING"] = "Existing";
  AgreementOption["NEW"] = "New";
})(AgreementOption || (AgreementOption = {}));
export const chosenAgreement = atom({
  key: 'chosenAgreement',
  default: null
});
export const newAgreementName = atom({
  key: 'newAgreementName',
  default: ''
});
export const agreementOption = atom({
  key: 'agreementOption',
  default: AgreementOption.EXISTING
});